import React, { useState, useEffect, useRef } from "react";
import BackendLayout from "../layouts/BackendLayout";
import InputLabel from "../components/InputLabel";
import Pagination from "../components/Pagination";
import Select2 from "../components/Select2";
import slidersUpdateIcon from "../assets/icons/judgment-sliders-update.png";
import { FiCheckSquare } from "react-icons/fi";
import { FiUser, FiCalendar } from "react-icons/fi";
import Modal from "../components/modal/Modal";
import _ from "lodash";
import Table from "../components/table/Table";
import { useDispatch, useSelector } from "react-redux";
import usePagination from "../hooks/usePagination";
import { useSortTable } from "../hooks/useSort";
import { ArrayUtils } from "../utils";
import tenkenTheme from "../configs/themes/tenkenTheme";
import CalendarIcon from "../assets/icons/calendar-big-icon.svg";
import PageEditIcon from "../assets/icons/page-edit-icon.svg";
import SettingIcon from "../assets/icons/setting-big-icon.svg";
import VerifyUserIcon from "../assets/icons/verified-user-icon.svg";
import {
  formatDate,
  toDatetimeStr,
  formatDateTime,
} from "../utils/datetime-utils";
import { InspectionCard } from "../components/cards/InspectionCard";
import ToggleDisplay from "../components/toggles/ToggleDisplay";
import ScrollModalButtons from "../components/ScrollModalButtons"
import {
  ButtonFilterSearch,
  PageTitle,
  RemarkDetail,
  ButtonApprove,
  ButtonReject,
  CheckboxInput,
  DatetimePicker,
  Button,
  ErrorMessageAlert,
  FormGroupInput,
  ButtonDPad,
  InspectionResultWithUnit,
  JudgmentLimit,
  RedirectAlert,
  ButtonCloseModal,
  Label
} from "../components";
import { getRouteBreadcrumb } from "../services/BreadcrumbServices";
import { useDocumentTitle, useInspectionData, useTableInspectionItemsScroll } from "../hooks";
import { getJudgmentPageSetting } from "../api/setting/pageApi";
import { JUDGMENT } from "../constants/routes";
import { setPageSettings } from "../store/actions/pageActions";
import { approveAllAPI, postJudgmentAPI } from "../api/judgment/post-api";
import {
  clearButtonProcessing,
  clearComponentLoading,
  clearErrors,
  clearPageLoading,
  setAlertError,
  setAlertSuccess,
  setButtonProcessing,
  setComponentLoading,
  setErrors,
  setPageLoading,
} from "../store/actions";
import PageAlert from "../components/alerts/PageAlert";
import { errorStatusHandle } from "../utils/error-utils";
import useSubmit from "../hooks/useSubmit";
import { useSearchParams } from "react-router-dom";
import { fetchInspectionDetails } from "../api/inspections/fetchInspectionApi";
import CustomSpan from "../components/CustomSpan";
import {
  getInspectionResutlColor,
  getInspectionResutlBackground,
  getInspectionResutlSymbol,
  getInspectionRowBackground,
  getInspectionUnit,
} from "../utils/display-utils";
import LoadingSpinner from "../components/loading/LoadingSpinner";
import { changeOrder } from "../utils/common-utils";
import { updateUserSetting } from "../services/user-master/UserSettingServices";
import { USER_SETTING_CATEGORIES } from "../constants/app";
import {JUDGMENT_PAGE} from "../constants/pageName";
import useRedirectPage from "../hooks/useRedirectPage";
import ReadonlyComment from "../components/ReadonlyComment";
import ExpandablePanel from "../components/ExpandablePanel";
import { JudgmentResultText, TreatmentItemResultRow } from "../components/inspection-status/inspection-items";
import { Tabs } from "flowbite-react";

export default function Judgment() {
  // eslint-disable-next-line no-unused-vars
  useRedirectPage(JUDGMENT_PAGE);
  const validationErrorMessage = useRef();
  const [params, setParams] = useSearchParams();
  const dispatch = useDispatch();
  const breadcrumb = getRouteBreadcrumb(JUDGMENT);
  useDocumentTitle("承認状況 - 点検王");
  const { submit } = useSubmit();
  const [workSelected, setWorkSelected] = useState(null);
  const currentDate = new Date();
  const [startDate, setStartDate] = useState(formatDate(currentDate));
  const [endDate, setEndDate] = useState(formatDate(currentDate));
  const [approved, setApproved] = useState(false);
  const [rejected, setRejected] = useState(false);
  const [undetermined, setUndetermined] = useState(true);
  const [reload, setReload] = useState(0);
  const [modalError, setModalError] = useState(false);
  const machineColumn = useSelector(
    (s) => s.app_settings.machine_group.machine.name
  );
  const groupSettings = useSelector((s) => s.app_settings.machine_group);
  const user = useSelector((s) => s.auth.user);
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const inspectionResultFields = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_field
  );
  const tableInspectionRef = useRef(null);



  const [filter, setfilter] = useState({
    startDate: "",
    endDate: "",
    workflowId: "",
    approved: false,
    rejected: false,
    undetermined: true,
  });
  const {
    workflow,
    tableData,
    setTableData,
    noSortData,
    displayColumns,
    setDisplayColumns,
    myPageInspection,
    page,
    perPage,
    count,
    orderList,
    setPage,
    setPerPage,
    setOrderList,
  } = useInspectionData(filter, reload);
  const [displayColumnTmp, setDisplayColumnTmp] = useState(displayColumns);
  const [selectDisplayModal, setSelectDisplayModal] = useState(false);
  const [inspectionDetailData, setInspectionDetailData] = useState({});
  const [treatments, setTreatments] = useState([]);
  const [inspectionItems, setInspectionItems] = useState([]);
  const [judgments, setJudgments] = useState([]);
  const [workflowList, setWorkflowList] = useState([]);
  const { sortOrderList, handleSortColumn } = useSortTable(
    tableData,
    noSortData,
    setTableData
  );
  const { currentPage, setCurrentPage, paginatedData, pageSize, setPageSize } =
    usePagination(tableData, 10);
  const [openInspectionPanel, setOpenInspectionPanel] = useState(false);
  const [comment, setComment] = useState("");
  const [checkedIds, setCheckedIds] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [hasNgChecked, setHasNgChecked] = useState(false);
  const [bulkAction, setBulkAction] = useState(null);
  const [okChecked, setOkChecked] = useState([]);
  const [maxHeightTableTreatment, setMaxHeightTableTreatment] = useState({});
  const [ngChecked, setNgChecked] = useState([]);
  const [tabTreatment, setTabTreatment] = useState(1);
  const tableTreatmentRef = useRef({'tab_1': React.createRef()});
  const [actionAuthority, setActionAuthority] = useState({
    can_approve: false,
    can_reject: false,
  });
  const [approveAll, setApproveAll] = useState(false);
  const [resultCount, setResultCount] = useState({});
  const maxHeightTableInspection = useTableInspectionItemsScroll(tableInspectionRef, inspectionDetailData);
  const [confirmCommentModal, setConfirmConmentModal] = useState(false);
  const [currentAction, setCurrentAction] = useState(false);


  useEffect(() => {
    if (myPageInspection !== null) {
      dispatch(setComponentLoading("inspection-detail-modal"));
      fetchInspectionDetails(params.get("inspection"), filter.workflowId)
        .then((res) => {
          const inspection = res.data.inspection;
          inspection["machine_name"] = inspection.machine?.name;
          inspection["operation_start_datetime"] = inspection[
            "operation_start_datetime"
          ]
            ? toDatetimeStr(inspection["operation_start_datetime"])
            : "";
          inspection["registration_datetime"] = inspection[
            "registration_datetime"
          ]
            ? toDatetimeStr(inspection["registration_datetime"])
            : "";
          inspection["inspection_start_datetime"] = inspection[
            "inspection_start_datetime"
          ]
            ? toDatetimeStr(inspection["inspection_start_datetime"])
            : "";
          inspection["inspection_start_user_id"] =
            inspection?.inspection_start_user.name;
          inspection["operation_start_user_id"] =
            inspection?.operation_start_user.name;
          setActionAuthority({
            ...actionAuthority,
            can_approve: res.data.can_approve,
            can_reject: res.data.can_reject,
          });
          dispatch(clearComponentLoading("inspection-detail-modal"));
          setInspectionDetailData(inspection);
          setTreatments(res.data.treatments);
          setInspectionItems(res.data.inspection_items);
          setJudgments(res.data.judgments);
          setOpenInspectionPanel(true);
          setComment("");
          setModalError("");
          dispatch(clearPageLoading());
        })
        .catch((e) => {
          dispatch(clearComponentLoading("inspection-detail-modal"));
          dispatch(clearPageLoading());
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myPageInspection]);

  useEffect(() => {
    const refKey = `tab_${tabTreatment}`;
    if (!tableTreatmentRef.current[refKey]?.current) {
      setMaxHeightTableTreatment((prev) => ({
        ...prev,
        [refKey]: 0
      }));
      return;
    }

    const currentRef = tableTreatmentRef.current[refKey]?.current;
    const thead = currentRef.querySelector("thead");
    const theadHeight = thead ? thead.offsetHeight : 0;
    const rows = currentRef.querySelectorAll("tbody tr");

    if (rows.length < 11) {
      setMaxHeightTableTreatment((prev) => ({
        ...prev,
        [refKey]: 0
      }));
      return;
    }

    let rowsHeight = 0;
    for (let i = 0; i < Math.min(10, rows.length); i++) {
      rowsHeight += rows[i].offsetHeight;
    }
    setMaxHeightTableTreatment((prev) => ({
      ...prev,
      [refKey]: theadHeight + rowsHeight
    }));
  }, [tabTreatment, treatments]);

  useEffect(() => {
    const initFilters = {};

    dispatch(setPageLoading());
    getJudgmentPageSetting()
      .then((pageSettings) => {
        const workList = pageSettings.workflows?.map((work) => {
          return { value: work.id, label: work.name };
        });
        setWorkflowList(workList);
        if (params.get("workflow")) {
          const work = _.find(workList, {
            value: parseInt(params.get("workflow")),
          });
          if (work) {
            setWorkSelected(work);
            setfilter({ workflowId: work.value });
          }
        }
        if (!params.get("workflow")) {
          if (_.find(workList, pageSettings.user_setting.setting?.workflow)) {
            setWorkSelected(pageSettings.user_setting.setting?.workflow);
            initFilters.workflowId =
              pageSettings.user_setting.setting?.workflow?.value;
          }
        }
        if (!params.get("start_date")) {
          setStartDate(pageSettings.user_setting.setting?.startDate);
          initFilters.startDate = pageSettings.user_setting.setting?.startDate;
        }
        if (!params.get("end_date")) {
          setEndDate(pageSettings.user_setting.setting?.endDate);
          initFilters.endDate = pageSettings.user_setting.setting?.endDate;
        }
        if (!params.get("inspection")) {
          dispatch(clearPageLoading());
        }
        initFilters.undetermined = true;
        if (!_.isEmpty(initFilters)) {
          setfilter(initFilters);
        }
        dispatch(setPageSettings(pageSettings));
      })
      .catch((e) => {
        dispatch(clearPageLoading());
        errorStatusHandle(e.response);
      });

    if (params.get("workflow")) {
      initFilters.workflowId = parseInt(params.get("workflow"));
    }
    if (params.get("start_date")) {
      setStartDate(params.get("start_date"));
      initFilters.startDate = params.get("start_date");
    }
    if (params.get("end_date")) {
      setEndDate(params.get("end_date"));
      initFilters.endDate = params.get("end_date");
    }
    if (!_.isEmpty(initFilters)) {
      initFilters.undetermined = true;
      setfilter(initFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSort = (column) => {
    let currentOrder = changeOrder(orderList[column]);
    setOrderList({
      ...orderList,
      [column]: currentOrder,
    });
  };

  const updateSettings = async () => {
    const userSettingsData = {
      workflow: workSelected,
      startDate: startDate,
      endDate: endDate,
    };
    try {
      await updateUserSetting(
        userSettingsData,
        USER_SETTING_CATEGORIES.JUDGMENT
      );
    } catch (e) {
      errorStatusHandle(e);
    }
  };

  const handleOpenInspection = (inspectionId) => {
    dispatch(setComponentLoading("inspection-detail-modal"));
    setInspectionDetailData({});
    fetchInspectionDetails(inspectionId, workSelected.value)
      .then((res) => {
        const inspection = res.data.inspection;
        inspection["machine_name"] = inspection.machine?.name;
        inspection["operation_start_datetime"] = inspection[
          "operation_start_datetime"
        ]
          ? toDatetimeStr(inspection["operation_start_datetime"])
          : "";
        inspection["registration_datetime"] = inspection[
          "registration_datetime"
        ]
          ? toDatetimeStr(inspection["registration_datetime"])
          : "";
        inspection["inspection_start_datetime"] = inspection[
          "inspection_start_datetime"
        ]
          ? toDatetimeStr(inspection["inspection_start_datetime"])
          : "";
        inspection["inspection_start_user_id"] =
          inspection?.inspection_start_user?.name;
        inspection["operation_start_user_id"] =
          inspection?.operation_start_user?.name;
        setInspectionDetailData(inspection);
        setTreatments(res.data.treatments);
        setInspectionItems(res.data.inspection_items);
        setJudgments(res.data.judgments);
        setActionAuthority({
          ...actionAuthority,
          can_approve: res.data.can_approve,
          can_reject: res.data.can_reject,
        });
        dispatch(clearComponentLoading("inspection-detail-modal"));
      })
      .catch((e) => {
        errorStatusHandle(e);
        dispatch(clearComponentLoading("inspection-detail-modal"));
      });
    setOpenInspectionPanel(true);
    setComment("");
    setModalError("");
    dispatch(clearErrors());
    dispatch(setAlertSuccess(""));
  };

  const handleChangeColumnDisplay = (column, display) => {
    setDisplayColumnTmp({ ...displayColumnTmp, [column]: display });
  };

  const handleCheckInspection = (e, id) => {
    setCheckedIds((ids) => {
      if (e.target.checked) {
        return [...ids, id];
      }
      const newIds = [...ids];
      _.pull(newIds, id);
      setCheckAll(false);
      return newIds;
    });
  };

  const handleCheckAll = (e) => {
    setCheckAll(e.target.checked);
    if (e.target.checked) {
      const newIds = tableData?.map((row) => row.id);
      setCheckedIds(newIds);
    } else {
      setCheckedIds([]);
    }
  };

  const handleSubmit = (data) => {
    submit(() => postJudgmentAPI(data))
      .then((res) => {
        dispatch(clearErrors());
        setOpenInspectionPanel(false);
        setCheckedIds([]);
        setCheckAll(false);
        dispatch(setAlertSuccess(res.message));
        setReload(reload + 1);
        dispatch(clearButtonProcessing("btn-bulk-judgment"));
        dispatch(clearButtonProcessing("btn-approve-judgment"));
        dispatch(clearButtonProcessing("btn-reject-judgment"));
      })
      .catch((e) => {
        errorStatusHandle(e.response);
        if (e.response?.status === 400) {
          let errors = e.response.data.error_message ?? [];
          let errorsDetail = Object.values(e.response.data.errors);
          errors = [...errors, ...errorsDetail];
          setModalError(errors);
          dispatch(setAlertSuccess(""));
          if (!openInspectionPanel) {
            dispatch(setAlertError(errors));
            dispatch(setErrors(e.response.data.errors));
          }
          dispatch(clearButtonProcessing("btn-bulk-judgment"));
          dispatch(clearButtonProcessing("btn-approve-judgment"));
          dispatch(clearButtonProcessing("btn-reject-judgment"));
          validationErrorMessage.current?.scrollIntoView();
        }
      });
  };

  const handleBulkAction = (action, submit = false) => {
    if (submit) {
      dispatch(setButtonProcessing("btn-bulk-judgment"));
      const newIds = tableData?.map((row) => row.id);
      const data = {
        workflow_id: workSelected.value,
        inspection_ids: checkedIds.length === 0 ? newIds : checkedIds,
        result: action,
      };
      handleSubmit(data);
      return;
    }
    setBulkAction(action);
    const rowChecked = _.filter(tableData, (obj) =>
      _.includes(checkedIds, obj.id)
    );

    if (tableData.length === 0) {
      if (!action) {
        dispatch(setAlertError("拒否可能な点検表が存在しません。"));
      } else {
        dispatch(setAlertError("承認可能な点検表が存在しません。"));
      }
      return;
    }

    if (!action) {
      setConfirmModal(true);
      return;
    }

    let okCheckedRow = [];
    let ngCheckedRow = [];
    let hasNg = false;
    if (rowChecked.length === 0) {
      okCheckedRow = _.filter(tableData, (obj) => obj.result);
      ngCheckedRow = _.filter(tableData, (obj) => !obj.result);
      hasNg = _.some(tableData, { result: 0 });
    } else {
      okCheckedRow = _.filter(rowChecked, (obj) => obj.result);
      ngCheckedRow = _.filter(rowChecked, (obj) => !obj.result);
      hasNg = _.some(rowChecked, { result: 0 });
    }
    setHasNgChecked(hasNg);
    setOkChecked(okCheckedRow);
    setNgChecked(ngCheckedRow);
    setConfirmModal(true);
  };

  const handleJudgment = (action, inspectionId, checkComment=true) => {
    const data = {
      workflow_id: workSelected?.value,
      inspection_ids: [inspectionId],
      result: action,
      comment: comment,
    };
    if (checkComment && comment.trim() === "") {
      setCurrentAction(action);
      setConfirmConmentModal(true);
      return;
    }
    dispatch(setButtonProcessing("btn-reject-judgment"));
    dispatch(setButtonProcessing("btn-approve-judgment"));
    handleSubmit(data);
  };

  const handleSearch = () => {
    if (workSelected?.value) {
      dispatch(setButtonProcessing("btn-search-judgment"));
    }
    updateSettings();
    setfilter({
      workflowId: workSelected?.value,
      endDate: endDate,
      startDate: startDate,
      undetermined: undetermined,
      approved: approved,
      rejected: rejected,
    });
    setModalError("");
    setCheckedIds([]);
    setCheckAll(false);
    dispatch(clearErrors());
    dispatch(setAlertSuccess(""));
  };

  const handleChangeFilter = (name, e) => {
    if (name === "startDate") {
      setStartDate(e);
    } else if (name === "endDate") {
      setEndDate(e);
    }
  };

  const handleApproveAll = (perform_approve) => {
    dispatch(setButtonProcessing("btn-approve-all"));
    approveAllAPI(perform_approve)
      .then((response) => {
        if (perform_approve) {
          dispatch(clearErrors());
          setOpenInspectionPanel(false);
          setCheckedIds([]);
          setCheckAll(false);
          if (response.success) {
            dispatch(setAlertSuccess(response.message));
          } else {
            dispatch(setAlertError(response.message));
          }
          setReload(reload + 1);
        } else {
          let okCount = _.filter(response.data, (i) => i === true).length;
          let ngCount = _.filter(response.data, (i) => i === false).length;
          setResultCount({ ok: okCount, ng: ngCount });
          setApproveAll(true);
        }
      })
      .catch((e) => {
        errorStatusHandle(e.response);
      })
      .finally(() => {
        dispatch(clearButtonProcessing("btn-approve-all"));
      });
  };

  return (
    <BackendLayout sidebar={true} breadcrumb={breadcrumb}>
      <div className="flex">
        <div className="w-[200px]">
          <PageTitle title="承認状況" />
        </div>
        <div className="mt-4">
          <Button
            theme={tenkenTheme.button}
            color="yellow"
            className="px-8"
            onClick={() => {
              handleApproveAll(false);
            }}
            id="btn-approve-all"
          >
            <FiCheckSquare size={20} className="text-[#212121]" />
            <span className="ml-1">全一括承認</span>
          </Button>
        </div>
      </div>
      <RedirectAlert />
      <PageAlert />
      <ButtonDPad />
      <div className="w-full min-w-[1200px]">
        <div className="judgment__header border border-tenken-gray-300">
          <form className="flex">
            <div className="w-fit">
              <InputLabel
                className="judgment__search--label"
                text="指定日（点検登録日）"
              />
              <div className="mt-[10px]">
                <div className="flex items-center relative">
                  <DatetimePicker
                    autoFocus
                    id="date-start"
                    name="startDate"
                    timeFormat={false}
                    className="w-[152px]"
                    onChange={handleChangeFilter}
                    value={startDate}
                  />
                  <span className="mx-2 text-[24px]">~</span>
                  <DatetimePicker
                    id="date-end"
                    name="endDate"
                    timeFormat={false}
                    className="w-[152px]"
                    onChange={handleChangeFilter}
                    value={endDate}
                  />
                </div>
              </div>
            </div>

            <div className="w-[280px] ml-4">
              <InputLabel className="judgment__search--label" text="承認設定" />
              <Select2
                className="mt-2.5 w-[280px]"
                classNamePrefix="react-select"
                options={workflowList}
                placeholder="まだ承認されていません"
                value={workSelected}
                name="approval_status"
                onChange={(e) => setWorkSelected(e)}
                maxLength={40}
              />
            </div>
            <div className="w-[340px] ml-4">
              <InputLabel className="judgment__search--label" text="表示条件" />
              <div className="flex gap-5">
                <CheckboxInput
                  id="undetermined-check"
                  name="undetermined"
                  label="判定前"
                  className="mt-5"
                  classLabel="mt-5"
                  checked={undetermined}
                  onChange={() => setUndetermined(!undetermined)}
                />
                <CheckboxInput
                  id="approved-check"
                  name="approved"
                  label="承認済み"
                  className="mt-5"
                  classLabel="mt-5"
                  checked={approved}
                  onChange={() => setApproved(!approved)}
                />
                <CheckboxInput
                  id="rejected-check"
                  name="rejected"
                  label="差し戻し済み"
                  className="mt-5"
                  classLabel="mt-5"
                  checked={rejected}
                  onChange={() => setRejected(!rejected)}
                />
              </div>
            </div>

            <div className="flex flex-col w-[120px] lg:ml-4">
              <div className="h-[24px]"></div>
              <ButtonFilterSearch
                onClick={handleSearch}
                className="mt-[10px]"
                id="btn-search-judgment"
              />
            </div>
          </form>
        </div>

        <div className="w-full flex justify-between items-center md:pl-1 py-4 xl:pl-2 md:min-w-[1000px] xl:min-w-[1160px] pr-6 2xl:pr-8">
          <div className="flex">
            <ButtonApprove
              onClick={() => handleBulkAction(true)}
              className="mr-8"
              id="btn-bulk-approve-judgment"
            >
              {checkedIds?.length ? "個別承認" : "一括承認"}
            </ButtonApprove>
            <ButtonReject onClick={() => handleBulkAction(false)}>
              {checkedIds?.length ? "個別差し戻し" : "一括差し戻し"}
            </ButtonReject>
          </div>
          <Button
            className="text-[#000000] flex justify-center items-center min-w-[180px] mt-[10px] enabled:hover:bg-gray-200 xl:px-5 xl:py-2.5 xl:w-[220px] xl:h-[44px] px-3 py-2 w-[200px] h-[38px] border rounded-[16px] bg-[#FAFAFA] border-tenken-gray-400"
            type="button"
            onClick={() => setSelectDisplayModal(true)}
          >
            <img
              src={slidersUpdateIcon}
              alt="新規追加"
              className="judgment__icon"
            />
            テーブルを設定する
          </Button>
        </div>
        <div className="min-w-full w-fit pr-6">
          <div className="rounded-[8px] border border-tenken-gray-300 md:min-w-[1000px] xl:min-w-[1160px]">
            <Table striped className="text-base">
              <Table.Head>
                <Table.HeadCell className="whitespace-nowrap w-[72px]">
                  <CheckboxInput checked={checkAll} onChange={handleCheckAll} />
                </Table.HeadCell>
                {displayColumns.group_1 && groupSettings.group_1.active && (
                  <Table.HeadCell className="whitespace-nowrap">
                    {groupSettings.group_1.name}
                  </Table.HeadCell>
                )}
                {displayColumns.group_2 && groupSettings.group_2.active && (
                  <Table.HeadCell className="whitespace-nowrap">
                    {groupSettings.group_2.name}
                  </Table.HeadCell>
                )}
                {displayColumns.group_3 && groupSettings.group_3.active && (
                  <Table.HeadCell className="whitespace-nowrap">
                    {groupSettings.group_3.name}
                  </Table.HeadCell>
                )}
                {displayColumns.group_4 && groupSettings.group_4.active && (
                  <Table.HeadCell className="whitespace-nowrap">
                    {groupSettings.group_4.name}
                  </Table.HeadCell>
                )}
                {displayColumns.group_5 && groupSettings.group_5.active && (
                  <Table.HeadCell className="whitespace-nowrap">
                    {groupSettings.group_5.name}
                  </Table.HeadCell>
                )}
                <Table.HeadCell
                  className="w-[240px] whitespace-nowrap normal-case"
                  sortable
                  order={orderList.machine_name}
                  onChangeOrder={() => handleSort("machine_name")}
                >
                  {machineColumn}
                </Table.HeadCell>
                {displayColumns.inspection_number && (
                  <Table.HeadCell className="w-[112px] whitespace-nowrap normal-case">
                    <span>点検回数</span>
                  </Table.HeadCell>
                )}
                {displayColumns.result && (
                  <Table.HeadCell
                    sortable
                    order={orderList.result}
                    onChangeOrder={() => handleSort("result")}
                    className="w-[124px]"
                  >
                    点検結果
                  </Table.HeadCell>
                )}
                {displayColumns.registration_datetime && (
                  <Table.HeadCell
                    className="w-[188px] whitespace-nowrap"
                    sortable
                    order={orderList.registration_datetime}
                    onChangeOrder={() => handleSort("registration_datetime")}
                  >
                    点検結果登録時間
                  </Table.HeadCell>
                )}
                {displayColumns.last_treatment_user && (
                  <Table.HeadCell
                    className="w-[240px] whitespace-nowrap"
                    sortable
                    order={orderList.last_treatment_user}
                    onChangeOrder={() => handleSort("last_treatment_user")}
                  >
                    処置状況
                  </Table.HeadCell>
                )}
                {displayColumns.last_treatment_datetime && (
                  <Table.HeadCell
                    className="min-w-[180px] whitespace-nowrap"
                    sortable
                    order={orderList.last_treatment_datetime}
                    onChangeOrder={() => handleSort("last_treatment_datetime")}
                  >
                    最終処置時間
                  </Table.HeadCell>
                )}
                {workflow &&
                  workflow.sequences.map(
                    (workOrder, order) =>
                      displayColumns[`judgment_${order}`] && (
                        <Table.HeadCell
                          className="w-[260px] whitespace-nowrap normal-case"
                          sortable
                          order={orderList[`judgment_${order + 1}`]}
                          onChangeOrder={() => handleSort(`name_${order + 1}`)}
                        >
                          {workOrder.type === 1
                            ? `${workOrder.user.name}(${workOrder.user.username})`
                            : workOrder.department.position.name}
                        </Table.HeadCell>
                      )
                  )}
              </Table.Head>
              <Table.Body className="relative">
                <LoadingSpinner component="judgment" />
                {tableData &&
                  tableData.map((row) => (
                    <Table.Row
                      style={{
                        background: getInspectionRowBackground(
                          row.result,
                          resultSymbolSetting
                        ),
                      }}
                    >
                      <Table.Cell>
                        <CheckboxInput
                          checked={_.includes(checkedIds, row.id)}
                          onChange={(e) => handleCheckInspection(e, row.id)}
                        />
                      </Table.Cell>
                      {ArrayUtils.range(1, 5).map(
                        (level) =>
                          displayColumns[`group_${level}`] && (
                            <Table.Cell className="max-w-[240px] truncate">
                              <span title={row[`group_${level}`]}>
                                {row[`group_${level}`]}
                              </span>
                            </Table.Cell>
                          )
                      )}
                      <Table.Cell className="max-w-[240px] truncate">
                        <span
                          className="font-normal text-blue-400 cursor-pointer"
                          onClick={() => handleOpenInspection(row.id)}
                          title={row.machine_name}
                        >
                          {row.machine_name}
                        </span>
                      </Table.Cell>
                      {displayColumns.inspection_number && (
                        <Table.Cell>
                          <span>{row.inspection_number}回目</span>
                        </Table.Cell>
                      )}
                      {displayColumns.result && (
                        <Table.Cell className="text-center">
                          <span
                            style={{
                              color: getInspectionResutlColor(
                                row.result,
                                resultSymbolSetting
                              ),
                            }}
                          >
                            {getInspectionResutlSymbol(
                              row.result,
                              resultSymbolSetting
                            )}
                          </span>
                        </Table.Cell>
                      )}
                      {displayColumns.registration_datetime && (
                        <Table.Cell>{row.registration_datetime}</Table.Cell>
                      )}
                      {displayColumns.last_treatment_user && (
                        <Table.Cell className="max-w-[240px] truncate">
                          <span title={row.last_treatment_user}>
                            {row.last_treatment_user}
                          </span>
                        </Table.Cell>
                      )}
                      {displayColumns.last_treatment_datetime && (
                        <Table.Cell>{row.last_treatment_datetime}</Table.Cell>
                      )}
                      {workflow.sequences.map(
                        (workOrder, order) =>
                          displayColumns[`judgment_${order}`] && (
                            <Table.Cell className="max-w-[260px] truncate">
                              {row.hasOwnProperty(`judgment_${order}_result`) &&
                               (
                                  <span
                                    style={{
                                      color: getInspectionResutlColor(
                                        row[`judgment_${order}_result`],
                                        resultSymbolSetting
                                      ),
                                    }}
                                    className="mr-1"
                                  >
                                    {getInspectionResutlSymbol(
                                      row[`judgment_${order}_result`],
                                      resultSymbolSetting
                                    )}
                                  </span>
                                )}
                              {row[`judgment_${order}`]}
                            </Table.Cell>
                          )
                      )}
                    </Table.Row>
                  ))}
                {paginatedData?.length === 0 && (
                  <Table.Row>
                    <Table.Cell colSpan={99}>検索結果は０件です。</Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </div>
        </div>
        <div className="md:mt-3 xl:mt-6 md:min-w-[1000px] xl:min-w-[1200px]">
          <Pagination
            setPage={setPage}
            currentPage={page}
            pageSize={perPage}
            setPageSize={setPerPage}
            totalCount={count}
          />
        </div>
      </div>
      <Modal
        dismissible
        size="6xl"
        show={selectDisplayModal}
        onClose={() => setSelectDisplayModal(false)}
        className="z-20"
      >
        <Modal.Header className="items-center h-[50px]">
          <p>テーブルの列を設定する</p>
        </Modal.Header>
        <Modal.Body className="overflow-x-hidden">
          <p>以下の設定に基づいて、結果テーブルの表示を調整できます。</p>
          <form>
            <div className="flex pt-3">
              <div className="w-[48%] pr-4">
                <div>
                  <div className="text-left bg-tenken-gray-200 border-[0.5px] border-tenken-gray-200">
                    <h3 className="px-2 py-3">機械と検査</h3>
                  </div>
                </div>
                {ArrayUtils.range(1, 5).map(
                  (level) =>
                    groupSettings &&
                    groupSettings[`group_${level}`]?.active && (
                      <ToggleDisplay
                        key={level}
                        column={`group_${level}`}
                        label={groupSettings[`group_${level}`].name}
                        onChange={handleChangeColumnDisplay}
                        checked={displayColumnTmp[`group_${level}`]}
                      />
                    )
                )}
                <ToggleDisplay
                  column="machine_name"
                  label={machineColumn}
                  disabled
                  checked={displayColumnTmp["machine_name"]}
                />
                <ToggleDisplay
                  column="inspection_number"
                  label="点検回数"
                  onChange={handleChangeColumnDisplay}
                  checked={displayColumnTmp["inspection_number"]}
                />
                <ToggleDisplay
                  column="result"
                  label="点検結果"
                  onChange={handleChangeColumnDisplay}
                  checked={displayColumnTmp["result"]}
                />
                <ToggleDisplay
                  column="registration_datetime"
                  label="点検結果登録時間"
                  onChange={handleChangeColumnDisplay}
                  checked={displayColumnTmp["registration_datetime"]}
                />
                <ToggleDisplay
                  column="last_treatment_user"
                  label="処置状況"
                  onChange={handleChangeColumnDisplay}
                  checked={displayColumnTmp["last_treatment_user"]}
                />
                <ToggleDisplay
                  column="last_treatment_datetime"
                  label="最終処置時間"
                  onChange={handleChangeColumnDisplay}
                  checked={displayColumnTmp["last_treatment_datetime"]}
                />
              </div>
              <div className="w-[48%] pl-4">
                <div>
                  <div className="text-left bg-tenken-gray-200 border-[0.5px] border-tenken-gray-200">
                    <h3 className="px-2 py-3">承認状況</h3>
                  </div>
                </div>
                {workflow &&
                  workflow.sequences.map((workOrder, order) => (
                    <ToggleDisplay
                      column={`judgment_${order}`}
                      label={
                        workOrder.type === 1
                          ? `${workOrder.user.name}(${workOrder.user.username})`
                          : workOrder.department.position.name
                      }
                      onChange={handleChangeColumnDisplay}
                      checked={displayColumnTmp[`judgment_${order}`]}
                    />
                  ))}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center h-[76px] border-tenken-gray-200 bg-tenken-gray-200">
          <Button
            theme={tenkenTheme.button}
            color="light"
            className="rounded-[6px] min-w-[140px] h-[40px] mr-8"
            onClick={(e) => setSelectDisplayModal(false)}
          >
            閉じる
          </Button>
          <Button
            theme={tenkenTheme.button}
            color="primary"
            className="rounded-[6px] min-w-[140px] h-[40px]"
            onClick={(e) => {
              setDisplayColumns({ ...displayColumnTmp });
              setSelectDisplayModal(false);
            }}
          >
            適用
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        dismissible
        show={openInspectionPanel}
        theme={tenkenTheme}
        position="top-right"
        size="7xl"
        className="relative hide-close custom-modal-size-8xl"
      >
        <div className="w-fit min-w-full">
          <LoadingSpinner component="inspection-detail-modal" />
          <Modal.Header className="flex justify-end px-[12px] py-[8px] bg-[#EEE] w-full border-none">
            <ButtonCloseModal
              onClick={() => setOpenInspectionPanel(false)}
            ></ButtonCloseModal>
          </Modal.Header>
          <Modal.Body className="bg-white">
            <div ref={validationErrorMessage}></div>
            <div className="flex flex-col justify-start gap-[24px] flex-1">
              {modalError && <ErrorMessageAlert error={modalError} />}
              <div className="flex items-center justify-between gap-4 self-stretch">
                <InspectionCard
                  title={"点検結果登録時間"}
                  detail={formatDate(
                    inspectionDetailData.registration_datetime
                  )}
                  width="w-[132px]"
                  className="w-[240px]"
                  imgSrc={CalendarIcon}
                />
                <InspectionCard
                  className="min-w-[300px]"
                  title={machineColumn}
                  detail={inspectionDetailData.machine_name}
                  imgSrc={SettingIcon}
                />
                <InspectionCard
                  className="min-w-[300px]"
                  title={"点検テンプレート名"}
                  detail={inspectionDetailData.template?.name}
                  imgSrc={PageEditIcon}
                />
                <InspectionCard
                  className="min-w-[300px]"
                  title={"処置担当者"}
                  detail={inspectionDetailData.last_treatment_user}
                  imgSrc={VerifyUserIcon}
                />
              </div>

              <div className="flex flex-col flex-start w-full max-w-[1722px] min-w-[980px] gap-[24px]">
                <div className="flex gap-[8px]">
                  <div className="w-1/2">
                    <div className="text-[22px] font-normal">
                      <span className="whitespace-nowrap">点検結果： </span>
                      <span
                        className="inline-block px-2"
                        style={{
                          color: getInspectionResutlColor(
                            inspectionDetailData?.result,
                            resultSymbolSetting
                          ),
                          background: getInspectionResutlBackground(
                            inspectionDetailData?.result,
                            resultSymbolSetting
                          ),
                        }}
                      >
                        {getInspectionResutlSymbol(
                          inspectionDetailData?.result,
                          resultSymbolSetting
                        )}
                      </span>
                    </div>
                    <div className="flex gap-6 mt-8">
                      <ButtonApprove
                        onClick={() =>
                          handleJudgment(true, inspectionDetailData.id)
                        }
                        id="btn-approve-judgment"
                        disabled={!actionAuthority.can_approve}
                      >
                        承認
                      </ButtonApprove>
                      <ButtonReject
                        onClick={() =>
                          handleJudgment(false, inspectionDetailData.id)
                        }
                        id="btn-reject-judgment"
                        disabled={!actionAuthority.can_reject}
                      >
                        拒否
                      </ButtonReject>
                    </div>
                  </div>
                  <div className="flex flex-col justify-center item-center gap-[6px] w-1/2">
                    <InputLabel
                      className="text-[14px] font-medium"
                      text="コメント一覧"
                    />
                    <textarea
                      id="message"
                      rows="4"
                      maxLength={400}
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      className="judgment__inspection-textarea"
                      placeholder="コメント一覧..."
                    ></textarea>
                  </div>
                </div>
                <ExpandablePanel title="点検結果">
                  <div id="inspection-detail" className="w-full">
                    <div
                      className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto"
                      style={{
                        maxHeight: maxHeightTableInspection
                          ? `${maxHeightTableInspection}px`
                          : "auto",
                      }}
                      ref={tableInspectionRef}
                    >
                      <Table className="no-drop-shadow-table" striped>
                        <Table.Head
                          className={`${
                            maxHeightTableInspection ? "sticky top-0 z-[8]" : ""
                          } border-b border-tenken-gray-200`}
                        >
                          <Table.HeadCell className="!normal-case w-[76px] scrollable-table-header-bg">
                            <span>No.</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="scrollable-table-header-bg">
                            <span className="whitespace-nowrap">点検項目</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="scrollable-table-header-bg">
                            <span className="whitespace-nowrap">判定基準</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="scrollable-table-header-bg">
                            <span className="whitespace-nowrap">下限</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="scrollable-table-header-bg">
                            <span className="whitespace-nowrap">上限</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="w-[2%] min-w-[75px] scrollable-table-header-bg" />
                          <Table.HeadCell className="w-[112px] scrollable-table-header-bg">
                            <span className="whitespace-nowrap">留意事項</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="min-w-[150px] scrollable-table-header-bg">
                            <span className="whitespace-nowrap">点検結果</span>
                          </Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="devide-y text-base">
                          {inspectionDetailData.items?.map((item, index) => (
                            <Table.Row className="odd:bg-gray-50 even:bg-white">
                              <Table.Cell>
                                <span>{index + 1}</span>
                              </Table.Cell>
                              <Table.Cell className="max-w-[400px]">
                                <span
                                  className="break-all"
                                  style={{
                                    color: item.inspection_item.title_color,
                                  }}
                                >
                                  {item.inspection_item.title}
                                </span>
                              </Table.Cell>
                              <Table.Cell className="max-w-[300px]">
                                <span
                                  className="break-all"
                                  style={{
                                    color:
                                      item.inspection_item.description_color,
                                  }}
                                >
                                  {item.inspection_item.description}
                                </span>
                              </Table.Cell>
                              <Table.Cell className="max-w-[300px]">
                                <JudgmentLimit
                                  value={
                                    item.inspection_item?.inspection_judgment
                                      ?.lower_value
                                  }
                                  boundaryType={
                                    item.inspection_item?.inspection_judgment
                                      ?.lower_boundary_type
                                  }
                                  unit={item.inspection_item?.unit}
                                  type="lower"
                                />
                              </Table.Cell>
                              <Table.Cell className="max-w-[300px]">
                                <JudgmentLimit
                                  value={
                                    item.inspection_item?.inspection_judgment
                                      ?.upper_value
                                  }
                                  boundaryType={
                                    item.inspection_item?.inspection_judgment
                                      ?.upper_boundary_type
                                  }
                                  unit={item.inspection_item?.unit}
                                  type="upper"
                                />
                              </Table.Cell>
                              <Table.Cell>
                                <span
                                  title={item.inspection_item?.unit}
                                  className="whitespace-nowrap"
                                >
                                  {item.inspection_item?.unit
                                    ? getInspectionUnit(
                                        item.inspection_item?.unit,
                                        true
                                      )
                                    : "-"}
                                </span>
                              </Table.Cell>
                              <Table.Cell>
                                <RemarkDetail
                                  key={index}
                                  rowData={item.inspection_item}
                                />
                              </Table.Cell>
                              <Table.Cell className="max-w-[300px]">
                                <span
                                  style={{
                                    color: getInspectionResutlColor(
                                      item.result,
                                      resultSymbolSetting
                                    ),
                                    background: getInspectionResutlBackground(
                                      item.result,
                                      resultSymbolSetting
                                    ),
                                  }}
                                >
                                  {getInspectionResutlSymbol(
                                    item.result,
                                    resultSymbolSetting
                                  )}
                                </span>
                                {item.inspection_item?.inspection_item_type
                                  ?.name === "input" && (
                                  <InspectionResultWithUnit
                                    inspectionResult={
                                      item.inspection_item_value
                                    }
                                    unit={item.inspection_item.unit}
                                    className="ml-1"
                                  />
                                )}
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                    <div className="relative rounded-lg border border-[#e0e0e0] mt-[24px]">
                      <Table striped theme={tenkenTheme.table}>
                        <Table.Head className="whitespace-nowrap">
                          <Table.HeadCell className="w-[43%] !bg-white">
                            <span>点検者情報</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="!bg-white"></Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="devide-y text-base whitespace-nowrap">
                          {inspectionResultFields
                            ? Object.entries(inspectionResultFields).map(
                                ([key, value]) =>
                                  key != "registration_datetime" && (
                                    <Table.Row className="odd:bg-gray-50 even:bg-white">
                                      <Table.Cell>
                                        <span className="tenken__text-gray-900">
                                          {value}
                                        </span>
                                      </Table.Cell>
                                      <Table.Cell>
                                        <FormGroupInput className="!flex-col">
                                          <FormGroupInput className="gap-[20px]">
                                            <CustomSpan
                                              text={inspectionDetailData[key]}
                                              className="2xl:text-[16px] tenken__text-gray-900 xl:text-[16px] md:text-[14px]"
                                            ></CustomSpan>
                                          </FormGroupInput>
                                        </FormGroupInput>
                                      </Table.Cell>
                                    </Table.Row>
                                  )
                              )
                            : null}
                        </Table.Body>
                      </Table>
                    </div>
                    <div className="flex flex-col bg-[#FFF] items-start self-stretch w-full xl:gap-[16px] gap-[12px] mt-8">
                      <label className="font-medium">点検コメント</label>
                      <ReadonlyComment
                        remarkText={inspectionDetailData?.remark_text}
                        commentFiles={
                          inspectionDetailData?.inspection_comment_files
                        }
                      />
                    </div>
                  </div>
                </ExpandablePanel>
                <ExpandablePanel title="処置結果">
                  {/* eslint-disable-next-line react/style-prop-object */}
                  {treatments?.length ? (
                    <Tabs
                      style="underline"
                      theme={tenkenTheme.treatment_tabs}
                      onActiveTabChange={(tab) => setTabTreatment(tab + 1)}
                    >
                      {treatments.map((treatment) => (
                        <Tabs.Item
                          title={`処置${treatment.treatment_number}回目`}
                          active={
                            tabTreatment === treatment.treatment_number + 1
                          }
                          key={treatment.treatment_number + 1}
                        >
                          <div className="flex flex-col px-[10px] gap-[20px]">
                            <div className="px-2.5 self-stretch flex item-center gap-[40px]">
                              <CustomSpan
                                className="font-medium text-gray-900 text-center"
                                text={`処置${treatment.treatment_number}回目`}
                              />
                              <div className="flex items-center gap-[10px]">
                                <FiUser size={20} className="font-medium" />
                                <CustomSpan
                                  className="font-medium text-gray-900 text-center"
                                  text={treatment.treatment_user.name}
                                />
                              </div>
                              <div className="flex items-center gap-[10px]">
                                <FiCalendar size={20} className="font-medium" />
                                <CustomSpan
                                  className="font-medium text-gray-900 text-center"
                                  text={formatDateTime(
                                    new Date(treatment.treatment_datetime)
                                  )}
                                />
                              </div>
                            </div>
                            <div
                              className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto"
                              style={{
                                maxHeight: maxHeightTableTreatment[
                                  `tab_${treatment.treatment_number + 1}`
                                ]
                                  ? `${
                                      maxHeightTableTreatment[
                                        `tab_${treatment.treatment_number + 1}`
                                      ]
                                    }px`
                                  : "auto",
                              }}
                              ref={
                                tableTreatmentRef.current[
                                  `tab_${treatment.treatment_number + 1}`
                                ] ??
                                (tableTreatmentRef.current[
                                  `tab_${treatment.treatment_number + 1}`
                                ] = React.createRef())
                              }
                            >
                              <Table className="no-drop-shadow-table" striped>
                                <Table.Head
                                  className={`${
                                    maxHeightTableTreatment[
                                      `tab_${treatment.treatment_number + 1}`
                                    ]
                                      ? "sticky top-0 z-[8]"
                                      : ""
                                  } border-b border-tenken-gray-200`}
                                >
                                  <Table.HeadCell className="!normal-case w-[2%] min-w-[75px] scrollable-table-header-bg">
                                    <span>No.</span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 max-w-[938px] scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      点検項目
                                    </span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      判定基準
                                    </span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      下限
                                    </span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      上限
                                    </span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg"></Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      留意事項
                                    </span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      点検結果
                                    </span>
                                  </Table.HeadCell>
                                </Table.Head>
                                <Table.Body className="devide-y text-base break-all">
                                  {treatment?.treatment_items?.inspection_result_content.map(
                                    (itemResult, i) => (
                                      <TreatmentItemResultRow
                                        itemId={itemResult.inspection_item_id}
                                        items={inspectionItems}
                                        itemResult={itemResult}
                                        treatmentNumber={
                                          treatment.treatment_number
                                        }
                                        key={i}
                                      />
                                    )
                                  )}
                                </Table.Body>
                              </Table>
                            </div>
                            <div className="flex flex-col bg-[#FFF] items-start self-stretch w-full xl:gap-[16px] gap-[12px]">
                              <Label
                                className="font-medium"
                                text="処置コメント"
                              />
                              <ReadonlyComment
                                remarkText={
                                  treatment.treatment_number === 0
                                    ? null
                                    : treatment.remark_text
                                }
                                commentFiles={
                                  treatment.treatment_number === 0
                                    ? null
                                    : treatment.treatment_comment_files
                                }
                                className={
                                  treatment.treatment_number === 0
                                    ? "bg-[#EEE]"
                                    : ""
                                }
                              />
                            </div>
                          </div>
                        </Tabs.Item>
                      ))}
                    </Tabs>
                  ) : inspectionDetailData.result === 0 ? (
                    <Tabs
                      style="underline"
                      theme={tenkenTheme.treatment_tabs}
                      onActiveTabChange={(tab) => setTabTreatment(tab + 1)}
                    >
                      <Tabs.Item
                        title={`処置0回目`}
                        active={tabTreatment === 1}
                        key={1}
                      >
                        <div className="flex flex-col px-[10px] gap-[20px]">
                          <div className="px-2.5 self-stretch flex item-center gap-[40px]">
                            <CustomSpan
                              className="font-medium text-gray-900 text-center"
                              text={`処置0回目`}
                            />
                            <div className="flex items-center gap-[10px]">
                              <FiUser size={20} className="font-medium" />
                              <CustomSpan
                                className="font-medium text-gray-900 text-center"
                                text={inspectionDetailData?.execution_user.name}
                              />
                            </div>
                            <div className="flex items-center gap-[10px]">
                              <FiCalendar size={20} className="font-medium" />
                              <CustomSpan
                                className="font-medium text-gray-900 text-center"
                                text={formatDateTime(
                                  new Date(
                                    inspectionDetailData?.registration_datetime
                                  )
                                )}
                              />
                            </div>
                          </div>
                          <div
                            className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto"
                            style={{
                              maxHeight: maxHeightTableTreatment[`tab_1`]
                                ? `${maxHeightTableTreatment[`tab_1`]}px`
                                : "auto",
                            }}
                            ref={
                              tableTreatmentRef.current[`tab_1`] ??
                              (tableTreatmentRef.current[`tab_1`] =
                                React.createRef())
                            }
                          >
                            <Table className="no-drop-shadow-table" striped>
                              <Table.Head
                                className={`${
                                  maxHeightTableTreatment[`tab_1`]
                                    ? "sticky top-0 z-[8]"
                                    : ""
                                } border-b border-tenken-gray-200`}
                              >
                                <Table.HeadCell className="!normal-case w-[2%] min-w-[75px] scrollable-table-header-bg">
                                  <span>No.</span>
                                </Table.HeadCell>
                                <Table.HeadCell className="px-1 max-w-[938px] scrollable-table-header-bg">
                                  <span className="whitespace-nowrap">
                                    点検項目
                                  </span>
                                </Table.HeadCell>
                                <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                  <span className="whitespace-nowrap">
                                    判定基準
                                  </span>
                                </Table.HeadCell>
                                <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                  <span className="whitespace-nowrap">
                                    下限
                                  </span>
                                </Table.HeadCell>
                                <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                  <span className="whitespace-nowrap">
                                    上限
                                  </span>
                                </Table.HeadCell>
                                <Table.HeadCell className="px-1 scrollable-table-header-bg"></Table.HeadCell>
                                <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                  <span className="whitespace-nowrap">
                                    留意事項
                                  </span>
                                </Table.HeadCell>
                                <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                  <span className="whitespace-nowrap">
                                    点検結果
                                  </span>
                                </Table.HeadCell>
                              </Table.Head>
                              <Table.Body className="devide-y text-base break-all">
                                {inspectionDetailData?.items.map(
                                  (itemResult, i) => (
                                    <TreatmentItemResultRow
                                      itemId={itemResult.inspection_item.id}
                                      items={inspectionItems}
                                      itemResult={itemResult}
                                      treatmentNumber={0}
                                      key={i}
                                    />
                                  )
                                )}
                              </Table.Body>
                            </Table>
                          </div>
                          <div className="flex flex-col bg-[#FFF] items-start self-stretch w-full xl:gap-[16px] gap-[12px]">
                            <Label
                              className="font-medium"
                              text="処置コメント"
                            />
                            <ReadonlyComment className="bg-[#EEE]" />
                          </div>
                        </div>
                      </Tabs.Item>
                    </Tabs>
                  ) : (
                    <span className="flex justify-center items-center w-full text-tenken-gray-700 text-base lg:text-[18px]">
                      処置履歴なし
                    </span>
                  )}
                </ExpandablePanel>
                <ExpandablePanel title="判定結果">
                  {judgments?.length > 0 ? (
                    <div className="relative rounded-lg border border-[#e0e0e0] w-full">
                      <Table className="no-drop-shadow-table" striped>
                        <Table.Head className="border-b border-tenken-gray-200">
                          <Table.HeadCell className="!normal-case w-[76px] !bg-white">
                            <span>No.</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="w-[320px] !bg-white">
                            <span>承認者</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="w-[180px] !bg-white">
                            <span>判定日</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="w-[120px] !bg-white">
                            <span>判定結果</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="!bg-white">
                            <span>判定コメント</span>
                          </Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="devide-y text-base">
                          {judgments.map((judgment, i) => (
                            <Table.Row
                              key={1}
                              className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200"
                            >
                              <Table.Cell>
                                <span>{i + 1}</span>
                              </Table.Cell>
                              <Table.Cell>
                                <span>{judgment.judgment_user.name}</span>
                              </Table.Cell>
                              <Table.Cell>
                                <span>
                                  {formatDate(judgment.judgment_datetime)}
                                </span>
                              </Table.Cell>
                              <Table.Cell className="w-[140px] whitespace-nowrap">
                                <JudgmentResultText result={judgment.result} />
                              </Table.Cell>
                              <Table.Cell>
                                <span className="whitespace-pre-wrap">
                                  {judgment.comment}
                                </span>
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                  ) : (
                    <span className="flex justify-center items-center w-full text-tenken-gray-700 text-base lg:text-[18px]">
                      判定履歴なし
                    </span>
                  )}
                </ExpandablePanel>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
      <Modal
        dismissible
        show={approveAll}
        onClose={() => setApproveAll(false)}
        theme={tenkenTheme}
        size="md"
      >
        <Modal.Body>
          <p>
            以下の条件で点検結果を全一括承認します。
            <br />
            ・処置が未完了の点検結果を含む
            <br />
            ・リストに表示されていない点検結果を含む
            <br />
            <br />
            本当によろしいですか？
            <br />
            承認者：{user.username} {user.name}
            <br />
            {resultSymbolSetting?.passed.symbol}：{resultCount.ok}
            <br />
            {resultSymbolSetting?.failed.symbol}：{resultCount.ng}
          </p>
        </Modal.Body>
        <Modal.Footer className="flex justify-center h-[76px] border-tenken-gray-200 bg-tenken-gray-200">
          <Button
            theme={tenkenTheme.button}
            color="gray"
            className="rounded-[6px] min-w-[140px] h-[40px] mr-8"
            onClick={() => setApproveAll(false)}
          >
            キャンセル
          </Button>
          <Button
            id="btn-bulk-judgment"
            theme={tenkenTheme.button}
            color="primary"
            className="rounded-[6px] min-w-[140px] h-[40px]"
            onClick={() => {
              setApproveAll(false);
              handleApproveAll(true);
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        dismissible
        show={confirmModal}
        onClose={() => setConfirmModal(false)}
        theme={tenkenTheme}
        size="md"
      >
        <Modal.Body>
          <p>
            {bulkAction === false
              ? "チェック状態の点検結果を一括差し戻しします。"
              : hasNgChecked
              ? "処置が未完了の点検結果も含めて一括承認します。"
              : "以下の点検結果を一括承認します。"}
          </p>
          <p>本当によろしいですか？</p>
          <p>
            承認者： {user.username} {user.name}
          </p>
          {bulkAction && (
            <>
              <p>
                {resultSymbolSetting.passed.symbol}： {okChecked.length}
              </p>
              <p>
                {resultSymbolSetting.failed.symbol}： {ngChecked.length}
              </p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="flex justify-center h-[76px] border-tenken-gray-200 bg-tenken-gray-200">
          <Button
            theme={tenkenTheme.button}
            color="gray"
            className="rounded-[6px] min-w-[140px] h-[40px] mr-8"
            onClick={() => setConfirmModal(false)}
          >
            キャンセル
          </Button>
          <Button
            id="btn-bulk-judgment"
            theme={tenkenTheme.button}
            color="primary"
            className="rounded-[6px] min-w-[140px] h-[40px]"
            onClick={() => {
              handleBulkAction(bulkAction, true);
              setConfirmModal(false);
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        dismissible
        show={confirmCommentModal}
        onClose={() => setConfirmConmentModal(false)}
        theme={tenkenTheme}
        size="md"
      >
        <Modal.Header className="items-center h-[50px]">
          <p>判定登録</p>
        </Modal.Header>
        <Modal.Body>
          <p>コメントが未入力ですがこのまま登録しますか？</p>
        </Modal.Body>
        <Modal.Footer className="flex justify-center h-[76px] border-tenken-gray-200 bg-tenken-gray-200">
          <Button
            theme={tenkenTheme.button}
            color="gray"
            className="rounded-[6px] min-w-[140px] h-[40px] mr-8"
            onClick={() => setConfirmConmentModal(false)}
          >
            戻る
          </Button>
          <Button
            id="btn-bulk-judgment"
            theme={tenkenTheme.button}
            color="primary"
            className="rounded-[6px] min-w-[140px] h-[40px]"
            onClick={() => {
              handleJudgment(currentAction, inspectionDetailData.id, false);
              setConfirmConmentModal(false);
            }}
          >
            登録
          </Button>
        </Modal.Footer>
      </Modal>
      {openInspectionPanel && <ScrollModalButtons />}
    </BackendLayout>
  );
}
